import {
	ActivatedRoute,
	ActivatedRouteSnapshot,
	NavigationExtras,
	Router,
} from '@angular/router';

import { ScreenModeService } from 'ib/internetbank-core/ib-services/screen-mode.service';
import { RouterUtils } from 'ib/internetbank-core/utils/router.utils';

import { VerificationEmailPopupComponent } from '../sections/settings/tabs/settings-tab-1/verification-email-popup/verification-email-popup.component';

import { AuthorizationGuardService } from './authorization-guard.service';

export interface AuthorizationRedirectRouteNavigate {
	url: string;
	queryParams?: Record<string, string>;
}

export class AuthorizationRedirectRouteUtils {
	public static getRedirectRoute(route: ActivatedRouteSnapshot): AuthorizationRedirectRouteNavigate {
		switch (true) {
			case route.firstChild?.url[0]?.path === VerificationEmailPopupComponent.routeSegment
				|| route.url[0]?.path === VerificationEmailPopupComponent.routeSegment:
				{
					return {
						url: '/settings/tab1',
						queryParams: { hash: route.queryParams.hash },
					};
				}

			default: {
				const returmUrl = AuthorizationGuardService.getReturnUrlFromQueryParameters(route.queryParams);

				return {
					url: RouterUtils.getPathFromUrl(returmUrl) || '/main',
					queryParams: RouterUtils.getQueryParametersFromUrl(returmUrl),
				};
			}
		}
	}

	public static redirectRoute(
		router: Router,
		screenModeService: ScreenModeService,
		activatedRoute: ActivatedRoute,
		url: string,
		extras?: NavigationExtras): void {

		const navigationUrl = ScreenModeService.getRouteLinkByScreenMode(
			(url || '')
				// в ссылке уже может быть включон сегмент mobile - его нужно потереть
				.replace('/mobile', ''),
		);

		router.navigate(navigationUrl, extras);
	}
}
